<template>
  <v-app>
    <!-- Header Start -->
    <header-partial></header-partial>
    <!-- Header End -->
    <!-- Content Start -->
    <v-content class="">
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <router-view></router-view>
        </v-slide-y-transition>
      </v-container>
    </v-content>
    <!-- Content End -->

    <!-- Footer Start -->
    <footer-partial></footer-partial>
    <!-- Footer End -->
  </v-app>
</template>

<script>
  import HeaderPartial from './components/partials/HeaderPartial.vue'
  import FooterPartial from './components/partials/FooterPartial.vue'

  export default {
    components: {
      HeaderPartial,
      FooterPartial
    }
  }
</script>



<style lang="stylus">
  $color-pack=false @import '~vuetify/src/stylus/main' @media only screen and (min-width: 1904px) {
    .container {
      max-width: 1185PX;
    }
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue